module.exports = {
      id: "comm-sports-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-sports",
      toString: function () {
        return this.url;
      }
    }